import { createContext } from 'react';

const AppHeaderContext = createContext();

export default AppHeaderContext;
